module.exports = __webpack_public_path__ + "d2cac89dde8cda380c8d16db1cf10c03.MP3";